import { render, staticRenderFns } from "./ShowsWidget.vue?vue&type=template&id=216876c4&"
import script from "./ShowsWidget.vue?vue&type=script&lang=js&"
export * from "./ShowsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports